export default {
  introduction: 'introduction',
  loading: 'loading',
  chartDisplay: 'chartDisplay',
};
